module.exports = __webpack_public_path__ + "img/p5-p1-molihua.b6120151.png";